import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "App-Top-Nav-Admin-H" }
const _hoisted_2 = { class: "App-Top-Nav" }
const _hoisted_3 = {
  key: 0,
  class: "App-Top-Nav-Left"
}
const _hoisted_4 = {
  key: 1,
  class: "App-Top-Nav-Center"
}
const _hoisted_5 = {
  key: 2,
  class: "App-Top-Nav-Right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "App-Top-Nav-B" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showLeft)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "left")
          ]))
        : _createCommentVNode("", true),
      (_ctx.showMiddle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "center")
          ]))
        : _createCommentVNode("", true),
      (_ctx.showRight)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "right")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}